import React, { useEffect, useState } from 'react'
import { Link, useLocation } from "react-router-dom";
import { GoSearch, GoInfo } from "react-icons/go"
import { HiHome, HiUser } from "react-icons/hi"
import styles from './Nav.module.css'

export const Nav = () => {

  const location = useLocation()
  const [active, setActive] = useState(location.pathname)

  useEffect(() => {
    setActive(location.pathname)
  }, [location])

  return (
    <nav className={styles.container}>
      <ul className={styles.items}>
        <li className={active === '/' ? styles.active : undefined} onClick={() => setActive('/')}>
          <Link to="/"><HiHome className={styles.icon} /></Link>
        </li>
        <li className={active === '/search' ? styles.active : undefined} onClick={() => setActive('/search')}>
          <Link to="/search"><GoSearch className={styles.icon} /></Link>
        </li>
        <li className={active === '/news' ? styles.active : undefined} onClick={() => setActive('/news')}>
          <Link to="/news"><GoInfo className={styles.icon} /></Link>
        </li>
        <li className={active === '/user' ? styles.active : undefined} onClick={() => setActive('/user')}>
          <Link to="/user"><HiUser className={styles.icon} /></Link>
        </li>
      </ul>
    </nav>
  )
}
